document.body.addEventListener('change', event => {
    if (event.target.closest('.subscription-group')) {
        event.stopImmediatePropagation();
        event.preventDefault();
        
        const selectElement = event.target;
        const selectedValue = selectElement.value;
        
        const sellingPlanParam = selectedValue ? `&selling_plan=${selectedValue}` : '&selling_plan=';
        const itemPath = `https://${window.location.host}/cart/change.js?line=${event.target.dataset.line}&quantity=${event.target.closest('.cart-product')?.dataset.qty}&sections=cart-drawer,main-cart${sellingPlanParam}`;

        fetch(itemPath, {
            method: 'POST',
            headers: {
                'Accept': 'application/json'
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`Error:${response.status} ${response}`);
            }
            return response.json();
        })
        .then(res => {
            const cart_count_elements = document.querySelectorAll('.cart-count');
            const cartDrawerInner = document.querySelector('.cart-drawer-inner');
            const mainCart = document.querySelector('.section-main-cart-container');
            let cartDrawerInfoText = cartDrawerInner?.querySelector('.cart-drawer__information_text');
            const replaceHTML = new DOMParser().parseFromString(res.sections?.['cart-drawer'] || '', 'text/html').querySelector('.cart-drawer-inner');
            
            if (replaceHTML) {
                if (cartDrawerInfoText) {
                    replaceHTML.querySelector('.cart-drawer-body').prepend(cartDrawerInfoText);
                }
                document.querySelector('.cart-drawer-inner').replaceWith(replaceHTML);
            } 
            if (mainCart && res.sections?.['main-cart']) {
                const newCartContent = new DOMParser().parseFromString(res.sections['main-cart'], 'text/html').querySelector('.section-main-cart-container');
                mainCart.replaceWith(newCartContent);
            }
            cart_count_elements.forEach(cart_count => {
                cart_count.innerHTML = replaceHTML.dataset.cart_count;
            });
        })
        .catch(error => {
            console.error( error);
        });
    }
})

document.body.addEventListener('change', event => {
    const productQty = event.target;
    
    var cartProductSelector = '.cart-product';
    
    if(productQty.closest(cartProductSelector)){
        const productQtyValue = parseInt(productQty.value);

        var updates = {
            [productQty.closest(cartProductSelector).dataset.itemId]: productQtyValue
        }

        var cartUpsell = document.querySelector('.cart-upsell')
        if(cartUpsell){
            var newCartUpsellId = cartUpsell.dataset.itemId;
            var newCartUpsellQty = cartUpsellQtyDetector(event);

            if(cartUpsell.querySelector('input[type="checkbox"]:checked')){
                updates[newCartUpsellId] = newCartUpsellQty;
            }
        }

        if( parseInt(productQtyValue) > parseInt(productQty.getAttribute('max')) ){

            const product = productQty.closest('.cart-product');
            const productQtyPicker = productQty.closest('product-quantity-picker');
            const productTitle = product.querySelector('.cart-product-title').innerText;
            const textQtyError = productQty.dataset.textQtyError;

            const errorParagraph = productQtyPicker.nextElementSibling;
            const isErrorExist = errorParagraph.classList.contains('error')
            const newErrorHTML = '<p class="error">' + textQtyError.replace('%qty', productQty.getAttribute('max') + ' ' + productTitle + ' - ' + productQty.dataset.textVariant) + '</p>';

            if( isErrorExist ){
                errorParagraph.innerHTML = newErrorHTML;
            }
            else{
                productQtyPicker.insertAdjacentHTML('afterend', newErrorHTML)
            }

            return false;
        }

        ChangeCartJson(updates);

    };

});

document.body.addEventListener('click', event => {

    var cartProductSelector = '.cart-product';
    var cartRemoveProductSelector = '.cart-product-remove';

    if(event.target.closest(cartRemoveProductSelector)){
        event.preventDefault();

        var itemId = event.target.closest(cartProductSelector).dataset.itemId;

        var updates = {
            [itemId]: 0
        }

        var cartUpsell = document.querySelector('.cart-upsell')
        if(cartUpsell){
            var newCartUpsellId = cartUpsell.dataset.itemId;
            var newCartUpsellQty = cartUpsellQtyDetector(event, itemId);

            if(cartUpsell.querySelector('input[type="checkbox"]:checked')){
                updates[newCartUpsellId] = newCartUpsellQty;
            }
        }

        ChangeCartJson(updates);

    }
});


document.body.addEventListener('change', event => {

    var cartUpsellSelector = '.cart-upsell';
    var cartUpsell = event.target.closest(cartUpsellSelector);

    if(cartUpsell){

        var cartUpsellItemId = cartUpsell.dataset.itemId
        var cartUpsellItemQty = cartUpsell.dataset.itemQty

        var updates = {
            [cartUpsellItemId]: cartUpsellItemQty
        }
        
        ChangeCartJson(updates);

    }
})

document.body.addEventListener('click', function (e) {
    const target = e.target.closest('.cart-drawer__information_text svg');
    
    if (!target) {
        return; 
    }
    target.closest('.cart-drawer__information_text').remove();
    
})

document.body.addEventListener('click', async function (e) {
    const discountRemove = e.target.closest('.cart_discount__remove');
    if (!discountRemove) {
        return; 
    }
    const code = discountRemove.dataset.discount;
    const existingDiscounts = existingDiscountsFunc();

    let currentDiscount = existingDiscounts.filter(discount => discount !== code);

    try {
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                updates: {},
                sections: 'cart-drawer,main-cart',
                discount: [...currentDiscount].join(',')
            })
        });
        if (!response.ok) {
            throw new Error(`HTTP error, status code: ${response.status}`);
        };

        const updatedCartData = await response.json();

        updatedCartFunc(updatedCartData);

    } catch (error) {
        console.error('Error while removing discount:', error);
    }
})

document.body.addEventListener('submit', async function (e) {
    
    const discountForm = e.target.closest('.discount__form_wrapper');
    if (!discountForm) {
        return; 
    }

    e.preventDefault();
    e.stopPropagation();

    discountForm.querySelector('.cartDiscountError').classList.add('hidden');
    discountForm.querySelector('.cartDiscountErrorDiscountCode').classList.add('hidden');
    
    const cartDrawerSelector = 'cart-drawer,main-cart';
    const discountInput = discountForm.querySelector('[name="discount__input"]');
    const discountCode = discountInput.value?.trim();

    if (!discountCode) {
        discountForm.querySelector('.cartDiscountError').innerText = "Please enter discount code.";
        discountForm.querySelector('.cartDiscountError').classList.remove('hidden');
        return;
    }

    const existingDiscounts = existingDiscountsFunc();

    if (existingDiscounts.includes(discountCode)) {
        discountInput.value = '';
        return;
    }

    try {
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                updates: {},
                sections: cartDrawerSelector,
                discount: [...existingDiscounts, discountCode].join(',')
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error, status code: ${response.status}`);
        }

        const updatedCartData = await response.json();

        const appliedDiscount = updatedCartData.discount_codes.find(discount => discount.code === discountCode);

        if (!appliedDiscount || !appliedDiscount.applicable) {
            discountForm.querySelector('.cartDiscountErrorDiscountCode').classList.remove('hidden');
            discountInput.value = '';
            return;
        }

        updatedCartFunc(updatedCartData);
        discountInput.value = '';
        

    } catch (error) {
        console.error('An error occurred while applying the discount:', error);
        discountForm.querySelector('.cartDiscountError').innerText = "Error applying discount.";
        discountForm.querySelector('.cartDiscountError').classList.remove('hidden');
        discountInput.value = '';
    }
});

function existingDiscountsFunc() {
    const discountCodes = [];
    const discountPills = document.querySelectorAll('.cart-totals-discounts-list-item');
    for (const pill of discountPills) {
      if (pill instanceof HTMLLIElement && typeof pill.dataset.discount === 'string') {
        discountCodes.push(pill.dataset.discount);
      }
    }
    return discountCodes;
}

function updatedCartFunc(cart) {
    const cart_count_elements = document.querySelectorAll('.cart-count');
    const cartDrawerInner = document.querySelector('.cart-drawer-inner');
    const mainCart = document.querySelector('.section-main-cart-container');
    let cartDrawerInfoText = cartDrawerInner?.querySelector('.cart-drawer__information_text');

    if (cartDrawerInner && cart.sections?.['cart-drawer']) {
        const newContent = new DOMParser().parseFromString(cart.sections['cart-drawer'], 'text/html').querySelector('.cart-drawer-inner');
        const freeShipping = newContent.querySelector('.cart-drawer-free-shipping');

        if (freeShipping) {
            const freegift1 = freeShipping.dataset.minFree_1Id;
            const freegift2 = freeShipping.dataset.minFree_2Id;
            const updatesFreeGifts = {};

            if (freegift1) {
                const existsFreeGift1 = cart.items.some(item => item.id == freegift1 && item.quantity > 0);
                if (parseInt(freeShipping.dataset.cartTotal) >= parseInt(freeShipping.dataset.minAmount)) {
                    if (!existsFreeGift1) {
                        updatesFreeGifts[freegift1] = 1;
                    }
                } else {
                    if (existsFreeGift1) {
                        updatesFreeGifts[freegift1] = 0;
                    }
                }
            }

            if (freegift2) {
                const existsFreeGift2 = cart.items.some(item => item.id == freegift2 && item.quantity > 0);
                if (parseInt(freeShipping.dataset.cartTotal) >= parseInt(freeShipping.dataset.minFree_2Amount)) {
                    if (!existsFreeGift2) {
                        updatesFreeGifts[freegift2] = 1;
                    }
                } else {
                    if (existsFreeGift2) {
                        updatesFreeGifts[freegift2] = 0;
                    }
                }
            }

            if (Object.keys(updatesFreeGifts).length > 0) {
                updateFreeGifts(updatesFreeGifts, cartDrawerInfoText);
            }
        }

        for(let cart_count of cart_count_elements){
            // cart_count.innerHTML = newContent.dataset.cart_count;
            cart_count.innerHTML = cart.item_count;
        }

        if (mainCart && cart.sections?.['main-cart']) {
            const newCartContent = new DOMParser().parseFromString(cart.sections['main-cart'], 'text/html').querySelector('.section-main-cart-container');
            mainCart.replaceWith(newCartContent);
        }
        
        if (newContent) {
            if (cartDrawerInfoText) {
                // newContent.querySelector('.cart-drawer-body').prepend(cartDrawerInfoText);
                cartDrawerInner.replaceWith(newContent);
            }else{
                cartDrawerInner.replaceWith(newContent);
            }
        }
        
        let cartRecommendationsSwiper = document.querySelector('.cart-drawer-recommendations-swiper');

        if (cartRecommendationsSwiper) {
            new Swiper(cartRecommendationsSwiper, {  
            loop: true,
            autoplay: {
                disableOnInteraction: false,
                delay: 5000,
            },
            pagination: {
                el: '.swiper-pagination', 
                clickable: true,          
                type: 'bullets',   
            }
            });
        }
        
        if(cart.item_count <= 0){
            document.querySelectorAll('.is-cart-drawer-products-empty')[0].classList.add('cart_products_is_empty');
            document.querySelectorAll('.is-cart-draw-footer-empty')[0].classList.add('cart_products_is_empty');
            document.querySelectorAll('.cart-drawer-empty-footer')[0].classList.remove('cart_products_is_empty');
            document.querySelectorAll('.cart-drawer-empty')[0].classList.remove('cart_products_is_empty');
        }else{
            document.querySelectorAll('.is-cart-drawer-products-empty')[0].classList.remove('cart_products_is_empty');
            document.querySelectorAll('.is-cart-draw-footer-empty')[0].classList.remove('cart_products_is_empty');
            document.querySelectorAll('.cart-drawer-empty-footer')[0].classList.add('cart_products_is_empty');
            document.querySelectorAll('.cart-drawer-empty')[0].classList.add('cart_products_is_empty');
        }
    }
}

function updateFreeGifts(updates,cartDrawerInfoText) {
    const cart_count_elements = document.querySelectorAll('.cart-count');
    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates,sections:'cart-drawer,main-cart' })
    })
    .then(response => response.json())
    .then(res => {
        const replaceMainCartHTML = new DOMParser().parseFromString(res.sections['main-cart'], 'text/html').querySelector('.section-main-cart-container');
        const replaceHTML = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html').querySelector('.cart-drawer-inner');
        if (replaceHTML) {
            if (cartDrawerInfoText) {
                replaceHTML.querySelector('.cart-drawer-body').prepend(cartDrawerInfoText);
            }
            document.querySelector('.cart-drawer-inner').replaceWith(replaceHTML);
            if (replaceMainCartHTML && document.querySelector('.section-main-cart-container')) {
                document.querySelector('.section-main-cart-container').replaceWith(replaceMainCartHTML);
            }
        }
        for(let cart_count of cart_count_elements){
            cart_count.innerHTML = replaceHTML.dataset.cart_count;
        }
    })
    .catch(error => {
        console.error('Error:', error);
    });
}

function cartUpsellQtyDetector(event, removeId = null){
    var cartProductSelector = '.cart-product';
    var cartProductsSelector = '.cart-products';

    const productQty = event.target;

    var cartProducts = productQty.closest(cartProductsSelector).querySelectorAll(cartProductSelector)
    var newQty = 0;
    var currentUpsellQty = 0;
    cartProducts.forEach(cartProduct => {

        if( removeId != cartProduct.dataset.itemId ){
            newQty += parseInt(cartProduct.querySelector('input[type="number"]').value)
        }
    })

    var cartUpsell = document.querySelector('.cart-upsell')
    var cartUpsellProductId = parseInt(cartUpsell.dataset.itemId);

    cartProducts.forEach(cartProduct => {
        if(cartProduct.dataset.itemId == cartUpsellProductId){
            currentUpsellQty = parseInt(cartProduct.querySelector('input[type="number"]').value);
        }
    });

    if(newQty <= 0){
        return newQty;
    }

    return newQty - currentUpsellQty;
}

function ChangeCartJson(updates){

    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates:updates,sections:'cart-drawer,main-cart', })
    })
    .then(response => {
        return response.json();
    })
    .then(res => {
        
        updatedCartFunc(res);
        // AjaxCartKeyUpdate(res);
        // AjaxCartUpdate(res, updates);
    })
    .catch((error) => {
        console.error('Error:', error);
    });

}


function AjaxCartKeyUpdate(cart){
  
    var cartProductsSelector = '.cart-products';
    var cartProductsSections = document.querySelectorAll(cartProductsSelector);
    
    cartProductsSections.forEach(cartProductsSection => {
      var cartProducts = cartProductsSection.querySelectorAll('.cart-product');

      cart.items.forEach((cartItem, index) =>{
          cartProducts[index].dataset.itemKey = cartItem.key;
      })
    })
  
}

function AjaxCartUpdate(cart, updates){
    var cart_count_elements = document.querySelectorAll('.cart-count');
    var cart_total_elements = document.querySelectorAll('.cart-total');
    var cart_total_discounts_elements = document.querySelectorAll('.cart-totals-discounts')
    var cart_total_discounts_list_elements = document.querySelectorAll('.cart-totals-discounts-list')
    var cart_discount_elements = document.querySelectorAll('.cart-discount');
    var cart_products_container = document.querySelector('.cart-products');
    var cart_products = document.querySelectorAll('.cart-product');

    var qty_input = '.product-quantity-picker-input';
    var line_discounts_selector = '.cart-product-details';
    var line_total_container_selector = '.cart-product-total';
    var line_total_selector = '.cart-product-line-price';
    var original_line_total_selector = '.cart-product-original-line-price';

    var cartAjaxDOM = new DOMParser().parseFromString(cart.sections['cart-drawer'], 'text/html').querySelector('.cart-drawer-inner');

    // Count update
    for(let cart_count of cart_count_elements){
        cart_count.innerHTML = cartAjaxDOM.dataset.cart_count;
    }

    // Total update
    for(let cart_total of cart_total_elements){
        var moneyFormat = document.body.dataset.moneyFormat;
        cart_total.innerHTML = Shopify.formatMoney(cart.original_total_price, moneyFormat)
    }

    // Discount update
    if(cart.total_discount != 0){
      for(let cart_total_discounts of cart_total_discounts_elements){
          if(!cart_total_discounts.classList.contains('cart-has-discount')){
            cart_total_discounts.classList.add('cart-has-discount');
          }
      }
    }
    else{
      for(let cart_total_discounts of cart_total_discounts_elements){
          cart_total_discounts.classList.remove('cart-has-discount');
      }
    }

    if(cart.cart_level_discount_applications.length > 0){
      cart.cart_level_discount_applications.forEach(function(discount, index){
        cart_total_discounts_list_elements.forEach(function(cart_total_discounts_list_element) {
          var list_items = cart_total_discounts_list_element.querySelectorAll('.cart-totals-discounts-list-item');
          
          if(!list_items[index].querySelector('span')){
            var list_item_span = document.createElement('span');
            list_items[index].appendChild(list_item_span);
          }
          list_items[index].querySelector('span').innerHTML = discount.discount_application.title
        })

      })
    }
    for(let cart_discount of cart_discount_elements){
        var moneyFormat = document.body.dataset.moneyFormat;
        cart_discount.innerHTML = Shopify.formatMoney(cart.total_discount, moneyFormat)
    }


    cart.items.forEach(item=>{
        var itemFound = false
        for( let cart_product of cart_products){
            if(cart_product.dataset.itemId == item.id){
                itemFound = true
            }
        }

        if(!itemFound){
            CartAddProduct(item)
        }
    })


    // var cart_products = document.querySelectorAll('.cart-product');
    for( let cart_product of cart_products){

        cartAjaxDOM.querySelectorAll('.cart-product').forEach(item=>{
            if (item.dataset.itemId == cart_product.dataset.itemId) {
                cart_product.querySelector(line_total_container_selector).innerHTML = item.querySelector(line_total_container_selector).innerHTML;
                cart_product.querySelector(line_discounts_selector).innerHTML = item.querySelector(line_discounts_selector).innerHTML;
            }
        })

        Object.keys(updates).forEach((itemId) => {
            var itemQty = updates[itemId];
            // Remove product
            if( itemQty == 0 && itemId == cart_product.dataset.itemId ){
                cart_product.remove()
            }
        })
    }

    // Cart upsell checkbox
    var cartUpsellElements = document.querySelectorAll('.cart-upsell');
    cartUpsellElements.forEach(cartUpsell => {
        var cartUpsellProductId = parseInt(cartUpsell.dataset.itemId);
        var isCartUpsellFound = false;

        cart.items.forEach(item=>{
            if( item.id === cartUpsellProductId ){
                isCartUpsellFound = true
            }
        })

        if(isCartUpsellFound){
            cartUpsell.querySelector('input[type="checkbox"]').checked = true
        }
        else{
            cartUpsell.querySelector('input[type="checkbox"]').checked = false
        }

        // Cart upsell qty update (if available)
        if(cartUpsell){
            if(!isCartUpsellFound){
                cartUpsell.dataset.itemQty = cart.item_count
            }
            else{
                cartUpsell.dataset.itemQty = 0
            }
        }
    })

    // Free Shipping bar & text progress update
    var cart_free_shipping_elements = document.querySelectorAll('.cart-free-shipping');

    for(let cart_free_shipping of cart_free_shipping_elements){

        var moneyFormat = document.body.dataset.moneyFormat;

        var cart_free_shipping_bar = cart_free_shipping.querySelector('.cart-free-shipping-bar');
        var cart_free_shipping_text = cart_free_shipping.querySelector('.cart-free-shipping-text');
        var cart_free_shipping_text_balance = cart_free_shipping.querySelector('.cart-free-shipping-text-balance');
        
        var min_amount = parseInt(cart_free_shipping.dataset.minAmount);

        if(cart.original_total_price > min_amount){
            if(!cart_free_shipping_text.classList.contains('has-free-shipping')){
                cart_free_shipping_text.classList.add('has-free-shipping')
            }
        }
        else{
            cart_free_shipping_text.classList.remove('has-free-shipping')
        }
        
        // Free shipping bar text balance 
        var balance_amount = min_amount - cart.original_total_price
        var current_percentage = (cart.original_total_price * 100) / min_amount
        
        if(cart_free_shipping_text_balance){
            cart_free_shipping_text_balance.innerHTML  = Shopify.formatMoney(balance_amount, moneyFormat)
        }

        if(cart_free_shipping_bar){
            cart_free_shipping_bar.style.setProperty('--width', current_percentage);
        }

    }
    
}

function CartAddProduct(newProduct){
    
    var cartUpsellElements = document.querySelectorAll('.cart-upsell');
    cartUpsellElements.forEach(cartUpsell => {
        // var cartUpsell = document.querySelector('.cart-upsell')
        cartUpsell.dataset.itemQty = 0
    });

    var getCartProductsSection = document.querySelectorAll('.cart-products');

    getCartProductsSection.forEach(getCartProducts => {
        var moneyFormat = document.body.dataset.moneyFormat;
        var getCartProduct = getCartProducts.querySelector('.cart-product:not(.cart-product-upsell').cloneNode(true);

        var cartProductThumbnail = getCartProduct.querySelector('.cart-product-thumbnail img');
        var cartProductThumbnailLink = getCartProduct.querySelector('.cart-product-thumbnail a');
        var cartProductTitleLink = getCartProduct.querySelector('.cart-product-title a');
        var cartProductPrice = getCartProduct.querySelector('.cart-product-price');
        var cartProductTotalPrice = getCartProduct.querySelector('.cart-product-line-price');
        var cartProductQty = getCartProduct.querySelector('.cart-product-qty input');
        var cartProductDl = getCartProduct.querySelector('dl');
        var cartProductSellingPlan = getCartProduct.querySelector('.cart-product-selling-plan');
        var cartProductDiscounts = getCartProduct.querySelector('.cart-product-discounts');
        
        getCartProduct.dataset.itemKey = newProduct.key
        getCartProduct.dataset.itemId = newProduct.id

        getCartProduct.classList.add('cart-product-upsell');
        
        if(cartProductThumbnail){
            cartProductThumbnail.setAttribute('src', newProduct.image);
            cartProductThumbnail.setAttribute('srcset', '');
        }
        if(cartProductThumbnailLink){
            cartProductThumbnailLink.setAttribute('href', newProduct.url);
        }
        if(cartProductTitleLink){
            cartProductTitleLink.setAttribute('href', newProduct.url);
            cartProductTitleLink.innerHTML = newProduct.title;
        }
        if(cartProductPrice){
            cartProductPrice.innerHTML = Shopify.formatMoney(newProduct.price, moneyFormat);
        }
        if(cartProductTotalPrice){
            cartProductTotalPrice.innerHTML = Shopify.formatMoney(newProduct.line_price, moneyFormat);
        }
        if(cartProductQty){
            cartProductQty.disabled = true;
            cartProductQty.value = newProduct.quantity;
        }

        if(cartProductDl){
            cartProductDl.remove();
        }
        if(cartProductSellingPlan){
            cartProductSellingPlan.remove();
        }
        if(cartProductDiscounts){
            cartProductDiscounts.remove();
        }
        getCartProduct.querySelector('.cart-product-remove').remove();

        // It's important to use prepend to replace item key.
        getCartProducts.prepend(getCartProduct);
    })


}

class ShippingCalculator extends HTMLElement {
    constructor() {
        super();

        this.shippingCountry = document.querySelector('.shipping-calculator-country');
        this.shippingProvince = document.querySelector('.shipping-calculator-province');
        this.shippingZip = document.querySelector('.shipping-calculator-zip');
        this.shippingSubmit = document.querySelector('.shipping-calculator-submit');

        this.shippingRates = document.querySelector('.shipping-rates');
        this.shippingRatesContent = document.querySelector('.shipping-rates-content');

        this.shippingCountry.addEventListener('change', () => {
            // shippingCountry
            var chosenCountry = this.shippingCountry.options[this.shippingCountry.selectedIndex];

            var shippingProvinceJSON = chosenCountry.dataset.provinces

            this.generateOptionsFromJson(shippingProvinceJSON)
        })

        if(this.shippingProvince.children){
            this.shippingProvince.closest('div').classList.add('hide');
        }

        this.fetchShippingRates();
    }

    generateOptionsFromJson = (jsonString) => {
        var jsonArray = JSON.parse(jsonString);
        this.shippingProvince.innerHTML = '';

        if(jsonArray.length > 0){
            this.shippingProvince.closest('div').classList.remove('hide');

            jsonArray.forEach(item => {
                const [value, text] = item;
                const option = document.createElement('option');
                option.value = value;
                option.textContent = text;

                this.shippingProvince.appendChild(option);
            });
        }
        else{
            this.shippingProvince.closest('div').classList.add('hide');
        }
    }

    fetchShippingRates = () => {
        this.shippingSubmit.addEventListener('click', () => {
            var shippingAddress = {
                "shipping_address": {
                    "zip": this.shippingZip.value,
                    "country": this.shippingCountry.value,
                    "province": this.shippingProvince.value
                }
            }

            fetch(`${window.Shopify.routes.root}cart/shipping_rates.json`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(shippingAddress)
            })
            .then(response => response.json())
            .then(res => {
                this.processShippingRates(res);
            })
        })
    }

    processShippingRates = (res) => {
        console.log("res", res)
        var shippingRates = res.shipping_rates;

        this.shippingRatesContent.innerHTML = '';
        var shippingUlElement = document.createElement('ul');        

        if(shippingRates){
            shippingRates.forEach(shippingRate => {
                var moneyFormat = document.body.dataset.moneyFormat;
                var shippingRatePrice = Shopify.formatMoney(shippingRate.price, moneyFormat)

                var shippingliElement = document.createElement('li');
                shippingliElement.innerHTML = '<span>' + shippingRate.name + ': </span><span>' + shippingRatePrice + '</span>';

                shippingUlElement.appendChild(shippingliElement)
            })

            this.shippingRatesContent.appendChild(shippingUlElement);
        }
        else{
            var shippingErrors = res.zip;
            shippingErrors.forEach(shippingError => {
                var shippingliElement = document.createElement('li');
                shippingliElement.innerHTML = shippingError
                shippingUlElement.appendChild(shippingliElement)
            })

            this.shippingRatesContent.appendChild(shippingUlElement);
        }

        if(!this.shippingRates.classList.contains('active')){
            this.shippingRates.classList.add('active');
        }
    }
}

customElements.define('shipping-calculator', ShippingCalculator)

class CartRecommendation extends HTMLElement {
    constructor(){
        super();

        this.splideArrows = this.querySelector('.splide__arrows').cloneNode(true);
        this.splideProgress = this.querySelector('.splide__progress').cloneNode(true);
        
        // var sectionId = this.dataset.sectionId;
        this.columnsCount = parseInt(this.dataset.columnsCount);
        this.carousel = this.dataset.carousel === 'true';


        this.productsId = this.dataset.productsId.split(',');
        this.productsId = this.productsId.filter(n => n)

        this.limit = this.dataset.limit
        this.intent = this.dataset.intent

        // console.log('this.productsId', this.productsId)

        var recommendedProductsList = document.createElement('ul');
        recommendedProductsList.classList.add('product-recommendations-list');
        
        // this.appendChild(recommendedProductsList);
        this.innerHTML = recommendedProductsList.outerHTML;

        this.productIds = [];

        var index = 0;
        
        this.fetchProducts(this.productsId[index], index); 
        this.parentElement.style.display = 'none';
    }

    fetchProducts = async (productId, index) => {
        return await fetch(window.Shopify.routes.root + `recommendations/products?product_id=${productId}&section_id=product-recommendations&limit=${this.limit}&intent=${this.intent}`)
            .then(response => response.text())
            .then((text) => {
                if(text.length == 0){
                    return false;
                }

                var productIterationIndex = 0

                var productsIdIterationIndex = index + 1;

                var html = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');

                var products = html.querySelectorAll('.product');

                products.forEach((product, productIndex) => {
                    productIterationIndex = productIndex + 1;

                    var fetchedProductId = product.dataset.productId;

                    if(!this.productIds.includes(fetchedProductId) && fetchedProductId != '10800227975361' && fetchedProductId != '10813268787393' && fetchedProductId != '10813215080641' && fetchedProductId != '10839950229697' ){ // Avoid adding duplicate products and exclude the target product ID
                        this.productIds.push(product.dataset.productId);

                        const actionsElement = product.querySelector('.product__actions');
                        product.querySelector('.jdgm-prev-badge__text').innerText = product.querySelector('.jdgm-prev-badge__stars').dataset.score;

                        if (actionsElement && !this.dataset.cartPage) {
                            product.appendChild(actionsElement);
                        }
                        

                        // const productsLazyloadImages = product.querySelectorAll('.lazy-loading-image');
                        // productsLazyloadImages.forEach(imageContainer => {
                        //     lazyloading(imageContainer);
                        // })

                        if(this.querySelectorAll('li').length < this.limit){

                            // const productsLazyloadImages = product.querySelectorAll('.lazy-loading-image');
                            // productsLazyloadImages.forEach(imageContainer => {
                            //     lazyloading(imageContainer);
                            // })

                            this.querySelector('.product-recommendations-list').appendChild(product);
                        }

                        if(this.querySelectorAll('li').length == this.limit ){
                            if(!this.querySelector('.product-recommendations-list').classList.contains('splide') && this.carousel){
                                // console.log("carousel to be initiated")
                                this.processCarousel();
                            } 
                        }
                    }
                })
                
                if(products.length == productIterationIndex && this.productsId.length == productsIdIterationIndex ){
                    
                    if(!this.querySelector('.product-recommendations-list').classList.contains('splide') && this.carousel){
                        // console.log("carousel to be initiated")
                        this.processCarousel();
                    } 
                    if (!this.querySelectorAll('li').length) {
                        this.parentElement.style.display = 'none';
                    }
                }

                if(productsIdIterationIndex < this.productsId.length){
                    this.fetchProducts(this.productsId[productsIdIterationIndex], productsIdIterationIndex); 
                }
            })
    }

    processCarousel = () => {
        this.parentElement.style.display = 'block';
        // var carousel = this.dataset.carousel === 'true';
        var columnsOffset = this.dataset.columnsOffset === 'true';
        var carouselOptions = JSON.parse(this.dataset.options);

        var productsList = this.querySelector('.product-recommendations-list');
        var products = this.querySelectorAll('.product-recommendations-list li');

        var productsListWrap = document.createElement('div');

        for (const className of productsList.classList) {
            productsListWrap.classList.add(className)
        }

        for (const product of products){
            product.classList.add('splide__slide')
        }

        productsListWrap.classList.add('has-carousel');
        productsListWrap.classList.add('splide');


        var splideTrack = document.createElement('div');

        splideTrack.classList.add('splide__track');


        productsList.classList.add('splide__list');
        productsList.classList.remove('product-recommendations-list');


        splideTrack.appendChild(productsList);

        productsListWrap.appendChild(splideTrack);
        productsListWrap.appendChild(this.splideArrows);

        if(this.splideProgress){
            productsListWrap.appendChild(this.splideProgress);
        }
        
        if(columnsOffset){
            productsListWrap.classList.add('has-carousel-columns-offset');

            carouselOptions['autoWidth'] = true
        }

        carouselOptions['classes'] = {
            arrows: 'splide__arrows',
            arrow : 'splide__arrow',
            prev  : 'splide__arrow--prev',
            next  : 'splide__arrow--next',
        };
        
        const splide = new Splide(productsListWrap, carouselOptions);

        var splideBar = splide.root.querySelector( '.splide__progress-bar' );

        if( splideBar ){
            // Updates the bar width whenever the carousel moves:
            splide.on( 'mounted move', function () {
                var end  = splide.Components.Controller.getEnd() + 1;
                var rate = Math.min( ( splide.index + 1 ) / end, 1 );
                splideBar.style.width = String( 100 * rate ) + '%';
            } );
        }

        splide.mount();
        
        this.appendChild(productsListWrap)
    }
}
customElements.define('cart-recommendations', CartRecommendation)